const { createSlice } = require("@reduxjs/toolkit");
const { getBabyNames } = require("reduxStore/actions/babyNames");

const initialStates = {
    loading: false,
    error: null,
    names: [],
};

const babyNamesSlice = createSlice({
    name: 'babyNames',
    initialState: initialStates,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(getBabyNames.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(getBabyNames.fulfilled, (state, action) => {
            state.loading = false;
            state.names = action.payload;
        })
        .addCase(getBabyNames.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export default babyNamesSlice.reducer;

